import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function FeedbackFooter() {
    const { t } = useTranslation();
    return (<div className="bg-accent h-24 flex flex-col items-center justify-center">
                <div
                  tabIndex={0}
                  role="button"
                  className="border rounded-md border-base bg-base"
                  onKeyDown={(e) => {
                    window.location.href = 'mailto:yourmail@gmail.com';
                    e.preventDefault();
                  }}
                  onClick={(e) => {
                    window.location.href = 'mailto:info@gopanza.com?body=I want to provide Feedback';
                    e.preventDefault();
                  }}
                >
                <div className="px-4 py-2 text-white">
                 {t('prompt_feedback')}
                </div>                 
                </div>
            </div>)
}
export default FeedbackFooter;
